/* TODO REFACTORING */
import { memo, useCallback, useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useLocations from 'hooks/useLocations';
import useCustomSelector from 'hooks/useCustomSelector';
import { locationsSelectors } from 'features/locations'

const LocationsAutocomplete = ({ multiple = false, fullWidth = false, margin = 'none', sx, value, error, helperText, onChange }) => {
  const { getLocations, clearLocalLocations } = useLocations();
  const { data, pagination } = useCustomSelector(locationsSelectors.getLocationsData)
  const fetching = useCustomSelector(locationsSelectors.locationsIsFetching)
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [firstTimeOpened, setFirstTimeOpened] = useState(false);

  const fetchLocations = useCallback(offset => {
    getLocations({ offset, query })
  }, [query, getLocations]);
  const handleScroll = ({ target: { scrollTop, scrollHeight, offsetHeight } }) => {
    if (scrollHeight === scrollTop + offsetHeight + 100) {
      const { limit, offset, count, total_count } = pagination;

      total_count > count + offset && fetchLocations(limit + offset);
    }
  };

  useEffect(() => {
    if (firstTimeOpened) {
      clearLocalLocations();
      fetchLocations(0);
    }

    return clearLocalLocations;
  }, [clearLocalLocations, fetchLocations, firstTimeOpened]);

  return (
    <Autocomplete
      disablePortal
      multiple={multiple}
      fullWidth={fullWidth}
      sx={sx}
      id='companies'
      isOptionEqualToValue={(o, v) => o.id === v.id}
      getOptionLabel={o => o.name}
      options={data}
      open={open}
      onOpen={() => { setOpen(true); if (!firstTimeOpened) setFirstTimeOpened(true); }}
      onClose={() => setOpen(false)}
      value={value}
      onChange={(_, formattedValue) => onChange({ 
        value: multiple ? _map(formattedValue, ({ id }) => id) : formattedValue?.id, 
        formattedValue, 
        error: '' }
      )}
      loading={fetching}
      inputValue={query}
      onInputChange={(_, value) => setQuery(value)}
      ListboxProps={{ onScroll: handleScroll }}
      renderInput={params =>
        <TextField
          {...params}
          margin={margin}
          label={`Select location${ multiple ? 's' : ''}`}
          error={error}
          helperText={helperText}
          InputProps={{
            ...params.InputProps,
            endAdornment: <>
              {fetching && <CircularProgress color="inherit" size={20} />}
              {params.InputProps.endAdornment}
            </>
          }}
        />
      }
    />
  );
};

LocationsAutocomplete.propTypes = {
  fullWidth: PropTypes.bool,
  margin: PropTypes.string,
  value: PropTypes.oneOfType([ PropTypes.array, PropTypes.object ]),
  onChange: PropTypes.func.isRequired
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <LocationsAutocomplete {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);